module.exports = __webpack_public_path__ + "ae87c81bd1f984266a9eae97dbd1bd27.svg";